import React from 'react';
import styled from 'styled-components';
import LoadingMask from '../../../CommonComponents/LoadingMask';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const BodyWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;

const ExpensesLoadingView = () => (
  <>
    <HeaderWrapper>
      <LoadingMask isDark height="45px" width="250px" />
      <LoadingMask isDark height="45px" width="400px" />
    </HeaderWrapper>
    <BodyWrapper>
      <LoadingMask isDark height="500px" width="40%" />
      <LoadingMask isDark height="500px" width="40%" />
    </BodyWrapper>
  </>
);

export default ExpensesLoadingView;
